import React, { Suspense, lazy, useState, useCallback, useEffect } from "react";
import Helmet from "react-helmet";
import Link from "./LinkWithTransitionLock";
import { isMobile } from "mobile-device-detect";
import {
  TimelineMax,
  TweenMax,
  TweenLite,
  Linear,
  TextPlugin,
  ThrowPropsPlugin,
  EasePack,
  CSSPlugin,
  ScrollToPlugin,
  Power1,
  Power2,
  Power3,
  Power4,
  Expo,
  gsap,
} from "gsap";
import g from "gsap-scroll";
import ScrollTrigger from "gsap/ScrollTrigger";

import Video from "./Video";

import event2019 from "../images/event2019.jpg";
import event2020 from "../images/event2020.jpg";

class Page extends React.Component {
  constructor(props) {
    super(props);
  }

  // static contextType = VideoIsPlayedContext;

  componentDidMount() {
    if (window.location.hash === "#history") {
      setTimeout(() => {
        window.scrollTo({
          top: document.querySelector("#history").offsetTop + window_height,
          behavior: "smooth",
        });
      }, 400);
    }

    gsap.registerPlugin(ScrollTrigger);

    function installMediaQueryWatcher(mediaQuery, layoutChangedCallback) {
      var mql = window.matchMedia(mediaQuery);
      mql.addListener(function(e) {
        return layoutChangedCallback(e.matches);
      });
      layoutChangedCallback(mql.matches);
    }

    // document.querySelector("body").classList.add("overflow");

    var window_width = window.innerWidth;
    var window_height = window.innerHeight;
    var window_height_mobile = window.outerHeight;

    var language_article_wrap = document.querySelector(
      ".language_article_wrap"
    );
    var language_article = document.querySelectorAll(".language_article");
    var language_switch = document.querySelector(".language_switch");
    var swt_btn = language_switch.querySelectorAll(".swt_btn");
    for (let i = 0; i < swt_btn.length; i++) {
      swt_btn[i].onclick = function() {
        var c = 0;
        while (c < swt_btn.length) {
          swt_btn[c++].className = "swt_btn";
        }
        swt_btn[i].className = "swt_btn active";
        language_article.forEach((ele) => {
          var id = ele.id;
          var lan_id = swt_btn[i].dataset.lan;
          if (id == lan_id) {
            ele.classList.add("active");
            language_article_wrap.style.height =
              document.querySelector("#" + id).offsetHeight + "px";
          } else {
            ele.classList.remove("active");
          }
        });
      };
    }
  }

  componentWillUnmount() {}

  render() {
    return (
      <>
        <section className="concept section_container sticky">
          <div className="inner_content">
            <div className="language_switch">
              <div className="swt_btn active" data-lan="zh">
                中文
              </div>
              <div className="swt_btn" data-lan="en">
                EN
              </div>
            </div>
            <div className="row_area_m">
              <div className="col_1">
                <div className="col_box col_sticky">
                  <h3 className="section_main_title">策展理念</h3>
                </div>
              </div>
              <div className="col_2 language_article_wrap">
                <article
                  className="inner_article language_article active"
                  id="zh"
                >
                  <Video />
                  <p>
                    白色恐怖是台灣的集體創傷，難以計數的政治犯在無預警的狀況下，被迫離開家鄉，面對彷彿無盡的監獄歲月。綠島從日本殖民時期作為收容浮浪者（流浪者）的收容所，就已經為這座島嶼定位成為了流放之地。而國府時期做為收押政治犯的大牢，更見證了白恐歷史的肅殺與不堪回首。
                  </p>
                  <p>
                    事實上，這座位於台東外海，漂浮於黑潮洋面上的蕞爾之島，有著屬於自身的瑰麗風貌──優美的海洋景觀、皎潔的珊瑚沙灘、豐富的植物生態，乃至於神秘的原民遺跡……然而，過去肅殺的歷史看似遠離了，今日的綠島與世上大多數地方一樣，面臨更多新的衝擊，土地開發，觀光產業的蓬勃發展，為地方帶來了利益，也產生了衝擊。全球化的人口移動來了新的文化交會，往昔白色恐怖時期有形的牢獄，也幽微地轉向了更為無形的監禁。
                  </p>
                  <p>
                    本次的策展以「監禁」與「離散」兩個主題，來對照不同時代的生命處境。展覽邀請了政治受難者的後代、新住民導演、劇場工作者、錄像與視覺藝術創作者、文學創作者、聲音工作者，透過參與性藝術、非虛構創作、海島建築學、考古學、行為藝術乃至於長時間的駐點創作，從白恐的監禁與記憶作為鏡子，照向今日。
                  </p>
                  <p>
                    在「監禁」的議題方面，政治受難者後代黃立慧，透過母親的名字「月桃」，來連結與島民生活密切相關的月桃莖，以及曾經監禁在綠島的父親與舅舅，藉著這個日常生活中的，隱喻白恐時期裡，常常被忽略而變成了「不在場」的女性眷屬的角色。錄像創作者洪鈞元，在走訪了綠島的許多地點以後，決定以「縫」作為意象，並且參考政治犯的口述，虛擬出一段最後以失敗告終的越獄行動，既呈現出了島嶼「無處可逃」的處境，也點出了縫隙與契機的遍佈存在。
                  </p>
                  <p>
                    此外，作品長期關注鄉野傳說與野史的陳依純，從自己在綠島的「靈動」經驗出發，探索政治犯在收押於獨居房期間所可能產生的「幻覺」，並以此結合相關的當代議題。泰雅族原民女性，擅長於行為藝術創作的林安琪，從紋面族群「女人社」的神話裡面，關於風吹就會受孕生子的故事，連結到戒嚴時期綠島「新生訓導處」的新生處境。林傳凱則透過綠島與豐原兩個現場，交叉呈現出綠島新生訓導處「再叛亂案」的政治犯後代如何追尋長輩受難事蹟的故事。林子寧與李佳泓的《關於梅濟民：對照(吐字的人、綠島人)》，則以白色恐怖受難者及作家梅濟民為主角，以錄像的手法詮釋他的生平以及文學創作，勾勒出外省籍政治犯的生命處境。
                  </p>
                  <p>
                    在「離散」的議題方面，越南裔新住民紀錄片導演阮金紅與紀錄片工作者蔡崇隆，藉由島上越南新移民的故事，探討東南亞移工、台灣新移民以及原綠島住民之間的關係，也掀開了少有人織的綠島外籍移民的面貌。另外，文學創作者吳克威、蔡郁柔，經由深度的居民訪查、交往，以及廢村空間的走踏，以非虛構的文字創作以及走踏的藝術行動，將綠島從監牢變成觀光勝地的變化，做了巧妙的連結與譬喻。劇場工作者陳品蓉，則將昔日園區裡的哨兵據點，轉變成為交換中心，透過以物易物的方式，以「物品」作為線索，探討今日綠島的定居者與外來流動者之間的價值觀。視覺與觀念創作者廖烜榛、黃奕捷，則透過建築學的考古調查過程，與原住民創作者一起在綠島的燕子洞重建咾咕石屋，延伸了轉型正義議題的歷史縱深。
                  </p>
                  <p>
                    國外參展藝術家方面，近年來注重於臺灣威權遺址考察的日本創作者成子，以現地創作的方式，呈現出了非台灣人眼光中的綠島威權記憶。香港創作者李俊峰則以虛實交錯的方式，探討香港敏感的邊界意識，也間接回應了當代香港與中國之間愈來愈模糊的界線問題。而印尼藝術家胡丰文（FXHarsono）以蘇哈托政權下的華人遭受到屠殺的歷史為素材，拓印了無以數計受難者名字，呈現出台灣之外深刻的歷史傷痕。
                  </p>
                  <p>
                    除此之外，北藝大創作者團隊也參與此次的創作，施力嘉以蜂巢的概念，交相映射了政治犯以及當代人的生命處境。徐銘謙則以灰塵作為主題，將威權時期視人如塵土的情況，做了深刻的詮釋。而李畯玨、劉姵伶更透過解剖台的機械裝置，探討遭到死刑犯在槍決以後，成為「大體老師」的身體處境。
                  </p>
                  <p>
                    最後，這次的策展計畫中，特別邀請幾位創作者透過「現場藝術」的駐點方式，藉以產生參與式的創作。熟稔攝影議題的林彥翔，希望重建過去新生訓導處的暗房，以在地駐點的「照相館」模式，為今日的居民以及登島的觀光客提供新的連結。劉紀彤則以交叉敘事的方式，連結了過去的流麻溝游泳池與位於臺灣本島的楊逵東海花園，並且以藝術行動的方式，號召參與者一同重返現場，共同思索白恐歷史的今昔。此外，聲音創作者周心瑀則預計在駐點期間，帶領參與者以聲音與肢體互動的方式，體驗綠島的聲音地景。
                  </p>
                </article>
                <article className="inner_article language_article" id="en">
                  <Video />
                  <p>
                    The White Terror is Taiwan’s collective trauma, during which
                    countless political prisoners were unexpectedly taken away
                    from home and suddenly found themselves facing seemingly
                    unending imprisonment. Since the Japanese colonial period,
                    Green Island had been used for sheltering the so-called
                    “furosha” (vagrants), and from that period on, the island
                    was viewed as a place for exile. It later became the prison
                    for keeping political prisoners during the Nationalist Party
                    regime and witnessed the violent austerity and unbearable
                    sorrow in the era of the White Terror.
                  </p>
                  <p>
                    In reality, this small island off the coast of Taitung where
                    the Black Current passes, possesses its very own distinctive
                    beauty—the intoxicating seascape, pristine coral beaches,
                    abundant plant ecology, mysterious indigenous legacies, etc.
                    However, even though the harsh past might appear to be
                    buried, Green Island today faces more and new impacts, just
                    like many other places in the world: land development and
                    the flourishing tourism industry, while economically
                    benefitting the island, lead to various collisions. As
                    population migration in this era of globalization introduces
                    fresh cultural encounters, the tangible prison built in the
                    White Terror era is implicitly transformed into a rather
                    intangible form of imprisonment.
                  </p>
                  <p>
                    This exhibition is curated based on two themes –
                    “imprisonment” and “diaspora” to compare varying life
                    circumstances in different times. Featuring diverse types of
                    creators, including descendants of political prisoners, new
                    resident filmmakers, theater workers, video and visual
                    artists, literary writers, sound artists, etc., the
                    exhibition presents participatory art, non-fictional
                    creation, island architecture, archaeology, performance art
                    and long-period artist residency, through which the
                    imprisonment and memories of the White Terror era are
                    transformed into a mirror that reflects our modern-day
                    experiences.
                  </p>
                  <p>
                    In terms of “imprisonment,” artist Huang Li-Hui, a
                    descendant of political victims, makes use of her mother’s
                    name “Yueh-Tao” (a homonym of the plant, shellflower) to
                    form a connection with shellflower stem, a common material
                    closely linked with the life of the island’s inhabitants, as
                    well as her father and uncle, both were prisoned on Green
                    Island. Huang converts this everyday material into a
                    metaphor for the often neglected “absent” presence of female
                    family members in the history of the White Terror era. Video
                    artist Hong Jun-Yuan, after having visited various locations
                    on the island, decides to use the imagery of “gap/seam” and
                    fabricates a fictional jailbreak that eventually ends in
                    failure based on references to oral accounts of political
                    prisoners. Hong’s work not only points out the
                    “inescapability” of the prisoners’ situation on the island
                    but also the ubiquitous gaps and seams that symbolize
                    opportunities.
                  </p>
                  <p>
                    Moreover, Chen I-Chun, whose practice has focused on folk
                    legends and unofficial histories, uses her supernatural
                    experience of “paranormal activity” on Green Island as a
                    point of departure to explore potential “hallucinations”
                    that political prisoners might experience during solitary
                    confinement. Chen then combines this theme with related
                    contemporary issues. Atayal female artist Lin An-Chi
                    specializes in performance art and draws her inspiration
                    from “Temahahoi,” an indigenous tribe known for the facial
                    tattooing tradition, and its mythology of women being
                    impregnated by wind. Lin connects this story with the
                    situation of prisoners at the New Life Correction Center on
                    Green Island during the martial law period. Lin Chuan-Kai,
                    on the other hand, utilizes two sites respectively on Green
                    Island and in Fengyuan, to cross-present how the descendants
                    of political prisoners, who were involved in the case of
                    “re-rebellion” at the New Life Correction Center on Green
                    Island, pursue and revisit the sufferings of their elder
                    generation. About Mei Ji-Min: Contrast (The One Who Vomit
                    Words,Housecleaning ) by Lin Tzu-Ning and Lee Chia-Hung
                    centers on Mei Ji-Min, a White Terror victim and an author,
                    and interprets Mei’s life and literary works through videos
                    to delineate the life circumstances of mainland Chinese
                    political victims.
                  </p>
                  <p>
                    Discussing the subject of “diaspora,” Vietnamese new
                    resident documentary filmmakers Nguyen Kim-Hong and Tsai
                    Tsung-Lung explore the relationship between Southeast Asian
                    migrant workers, Taiwan’s new residents and native
                    inhabitants on Green Island through the story of Vietnamese
                    new immigrants on the island. Their project reveals the
                    lesser known life of foreign immigrants on Green Island.
                    Furthermore, literary writers Wu Ke-Wei and Tsai Yu-Jou have
                    conducted in-depth interviews and interacted with local
                    residents as well as visited ruinous spaces in abandoned
                    villages, using non-fictional writing and physical art
                    action to establish witty connections with and allusions to
                    Green Island’s transformation from a place of imprisonment
                    to a tourist destination. Theater worker Chen Ping-Jung
                    turns past guard points in the memorial park into an
                    exchange hub, where “objects” become clues via the form of
                    bartering, to investigate the interrelated values between
                    Green Island’s current residents and its temporary visitors.
                    Visual and conceptual artists Liao Xuan-Zhen and Huang
                    I-Chieh base their project on an archaeological research
                    into architecture and co-create a coral stone house at
                    Swallow Cave with indigenous artists, further extending the
                    historical dimension related to the issue of transitional
                    justice.
                  </p>
                  <p>
                    Several foreign artists are showcased in the exhibition as
                    well: Japanese artist Shigeko, whose practice has revolved
                    around investigating Taiwan’s authoritarian ruins in recent
                    years, adopts the approach of site-specific creation and
                    unveils memories about the authoritarian regime on Green
                    Island from a non-Taiwanese perspective. Hong Kong artist
                    Lee Chun-Feng employs an approach mixing the real and the
                    unreal to discuss the sensitive issue of border awareness in
                    Hong Kong. His work also indirectly responds to the
                    increasingly blurred boundaries between contemporary Hong
                    Kong and China. Indonesian artist FX Harsono draws his
                    material from the history of Chinese being massacred under
                    the Suharto regime. Using rubbing to reveal innumerous names
                    of victims, his work exposes a grave historical wound
                    outside Taiwan. In addition, a creative team from the Taipei
                    National University of the Arts (TNUA) also participates in
                    the creation of the exhibition: Shih Li-Jia employs the
                    concept of beehives to form an interreflection between the
                    political prisoners’ life circumstances and that of the
                    modern people. Xu Ming-Qian uses dust as his theme and
                    conveys a profound interpretation about how people were
                    treated as dust during the authoritarian era. With a
                    mechanical installation featuring an autopsy table, Lee
                    Chun-Chueh and Liu Pei-Ling’s work prompts thoughts and
                    discussions about executed prisoners’ bodies when they
                    become “body doners.”
                  </p>
                  <p>
                    Lastly, several artists are specially invited to carry out
                    residencies onsite to create “live art” in this curatorial
                    project and produce participatory works in the exhibition.
                    Lin Yan-Xiang, an expert in photography-related topics,
                    hopes to re-create the darkroom once existed at the New Life
                    Correction Center, and will station onsite to run a
                    “photography studio” to offer new connections for locals as
                    well as tourists on Green Island. Liu Chi-Tung, through
                    interweaving narratives, brings together the “Liumagou
                    swimming pool” on Green Island and Yang Kui’s “Tunghai
                    Garden” on the island of Taiwan, and initiates an art action
                    to gather participants to revisit the sites and reflect on
                    the past and present of the White Terror history. In
                    addition, sound artist Chou Hsin-Yu will lead participants
                    to experience Green Island’s soundscape through auditory and
                    physical interaction her residency on the island.
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>
        <section className="history section_container" id="history">
          <div className="inner_content">
            <div className="section_header_row">
              <h3 className="section_main_title">歷年回顧</h3>
            </div>
            <div className="grid_area_2_ms">
              <a
                href="https://www.2020greenislandartfest.info/"
                className="grid_item"
                target="_blank"
              >
                <div className="photo">
                  <img src={event2020} alt="如果，在邊緣，畫一個座標" />
                </div>
                <br />
                <div className="link_btn" target="_blank">
                  <div className="btn_text">
                    如果，在邊緣，畫一個座標 2020 ↗
                  </div>
                </div>
              </a>
              <a
                href="https://www.visitingno15liumagou.com/"
                className="grid_item"
                target="_blank"
              >
                <div className="photo">
                  <img src={event2019} alt="拜訪流麻溝十五號" />
                </div>
                <br />
                <div href="#" className="link_btn" target="_blank">
                  <div className="btn_text">拜訪流麻溝十五號 2019 ↗</div>
                </div>
              </a>
            </div>
          </div>
        </section>
        <Helmet
          title="關於展覽・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival"
          meta={[
            {
              name: `description`,
              content:
                "關於展覽・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:title`,
              content:
                "關於展覽・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:description`,
              content:
                "關於展覽・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:type`,
              content: `website`,
            },
            {
              property: `og:image`,
              content: require("../images/og_image.jpg"),
            },
          ]}
        ></Helmet>
      </>
    );
  }
}

export default Page;
